import React, { useState } from 'react';
import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';
import { FieldArray } from 'react-final-form-arrays';
import { CheckboxList } from '@zola/zola-ui/src/components/Form/CheckboxList';
import { Form, FormSpy } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import themes from './mockData/theme_styles';
import { ThemeContext } from './context';
import Header from './common/Header';
import {
  mapFontViewToSerializedStyles,
  mapButtonStylesToComponent,
  mapBackgroundToCSS,
} from './util/mappers';
import MultiPageLayout from './pageLayouts/MultiPageLayout';
import SinglePageLayout from './pageLayouts/SinglePageLayout';
import type { BaseLayoutProps } from './pageLayouts/types';
import { COMPONENTS } from './util/componentConstants';

type PublicV2Props = BaseLayoutProps;

const PublicV2: React.FC<PublicV2Props> = props => {
  const { wedding } = props;
  const { title, nav_items, slug } = wedding || {};
  const [themeKey, setThemeKey] = useState('lewis_assets');
  const theme = themes[themeKey as keyof typeof themes] || themes.cruise;
  const {
    typography: { h1_font, h2_font, h3_font, h4_font, body_font, p_font },
    background,
    light_or_dark,
    button_styles: { primary },
    header,
    homepage,
    container = {},
    page_layout,
  } = theme;
  const H1 = styled.h1`
    ${mapFontViewToSerializedStyles(h1_font)}
  `;
  const H2 = styled.h2`
    ${mapFontViewToSerializedStyles(h2_font)}
    ${MEDIA_QUERY.MOBILE} {
      font-size: ${Math.ceil((h2_font.font_size * 2) / 3)}px;
    }
  `;
  const H3 = styled.h3`
    ${mapFontViewToSerializedStyles(h3_font)}
  `;
  const H4 = styled.h4`
    ${mapFontViewToSerializedStyles(h4_font)}
  `;
  const P = styled.p`
    ${mapFontViewToSerializedStyles(p_font)}
  `;
  const Button = mapButtonStylesToComponent(primary);

  const [context, setContext] = useState({
    components: {
      H1,
      H2,
      H3,
      H4,
      P,
      Button,
    },
    header,
    light_or_dark,
    background,
    homepage,
    container,
    highlightedComponents: [],
  });

  const globalStyles = css`
    html {
      body {
        ${mapFontViewToSerializedStyles(body_font)}
        ${mapBackgroundToCSS(background)}
      }
    }
  `;

  const componentListOptions = Object.keys(COMPONENTS).map(c => ({
    value: c,
    // @ts-ignore
    label: COMPONENTS[c],
  }));

  return (
    <div>
      <Global styles={globalStyles} />
      <ThemeContext.Provider value={context}>
        <Header title={title} navItems={nav_items} slug={slug} />
        {page_layout === 'SINGLE' ? <SinglePageLayout /> : <MultiPageLayout {...props} />}
        <div
          style={{
            backgroundColor: 'white',
            width: '300px',
            border: '1px solid black',
            padding: '20px',
            marginTop: '20px',
          }}
        >
          <DropdownV3
            options={Object.keys(themes).map(t => ({ label: t, value: t }))}
            label="Theme Key"
            value={themeKey}
            onSelect={s => {
              if (s) {
                setThemeKey(s.toString());
              }
            }}
          />
        </div>
        <div
          style={{
            backgroundColor: 'white',
            width: '300px',
            border: '1px solid black',
            padding: '20px',
            marginTop: '20px',
          }}
        >
          Component Key
          <Form
            // eslint-disable-next-line
            onSubmit={v => console.log(v)}
            mutators={{
              ...arrayMutators,
            }}
            render={() => (
              <>
                <FieldArray name="components" options={componentListOptions}>
                  {({ fields, meta }) => (
                    <CheckboxList fields={fields} meta={meta} options={componentListOptions} />
                  )}
                </FieldArray>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) =>
                    setContext({ ...context, highlightedComponents: values.components })
                  }
                />
              </>
            )}
          />
        </div>
      </ThemeContext.Provider>
    </div>
  );
};

export default PublicV2;
